import { css } from 'lit'; export default css`:host {  --mds_core_table_sticky-column_border-width: 3px;}`;